<template>
  <router-view />
</template>

<script>
import {mapActions} from 'vuex';

export default {
  name: 'CrewTONS',

  /** mixins **/
  mixins: [],

  /** props **/
  props: {},

  /** data **/
  data() {
    return {};
  },

  /** methods**/
  methods: {
    ...mapActions(
        [
            'resetCrewTons',
            'resetKeyObjects',
            'resetVessels',
            'resetFormObjCrewKeys',
            'resetFormDataVesselTon',
            'resetVesselPagination',
            'resetFormTonPayload',
        ]
    )
  },

  /**  computed  **/
  computed: {},

  /** mounted **/
  mounted() {
  },

  /** created **/
  created() {
  },

  /** watch
   searchText : {
			handler : 'fetchUserList',
			immediate : true,
		}
   **/
  watch: {},

  /** destroyed **/
  destroyed() {
    this.resetVessels()
    this.resetCrewTons()
    this.resetKeyObjects()
    this.resetFormObjCrewKeys(),
    this.resetFormDataVesselTon(),
    this.resetVesselPagination()
    //this.resetFormTonPayload()
  },
};
</script>

<style scoped>

</style>
